// src/components/ProtectedRoute.js

import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

function ProtectedRoute({ children, allowedRoles }) {
  const { isAuthenticated, userRole, isLoading } = useContext(AuthContext);
  
  console.log('ProtectedRoute - Auth state:', { isAuthenticated, userRole, isLoading, allowedRoles });

  if (isLoading) {
    return <div>Loading authentication...</div>;
  }

  if (isAuthenticated && allowedRoles && !allowedRoles.includes(userRole)) {
    console.log('User is authenticated but not authorized for this route');
    return <Navigate to="/unauthorized" replace />;
  }

  console.log('Protected route rendered with isAuthenticated:', isAuthenticated);
  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

export default ProtectedRoute;